import type { PersonalWorkIssue, Project } from "../../../lib/brain-api";
export type WorkFilter = "open" | "progress" | "queued" | "done" | "all";
export type WorkSort = "custom" | "name" | "recent" | "oldest" | "attention";
export const openIssue = (i: PersonalWorkIssue) => i.statusCategory !== "done";
export function attentionReason(i: PersonalWorkIssue): string | null {
    if (!openIssue(i))
        return null;
    if (i.flagged || /block/i.test(i.status))
        return "Blocked";
    if (/approval|review|developer done/i.test(i.status))
        return "Waiting for review";
    if (i.statusCategory === "indeterminate" && Date.now() - Date.parse(i.updated) >= 14 * 86400000)
        return "No update for 14+ days";
    if (!i.projectIds.length)
        return "No matching Brain project";
    return null;
}
export function filterIssue(i: PersonalWorkIssue, filter: WorkFilter, query: string): boolean {
    const status = filter === "all" || filter === "open" && openIssue(i) || filter === "progress" && i.statusCategory === "indeterminate" || filter === "queued" && i.statusCategory === "new" || filter === "done" && !openIssue(i);
    return status && `${i.key} ${i.summary} ${i.status} ${i.workStreams.join(' ')}`.toLowerCase().includes(query.trim().toLowerCase());
}
export function sortIssues(rows: PersonalWorkIssue[], sort: WorkSort): PersonalWorkIssue[] {
    return [...rows].sort((a, b) => sort === "name" ? a.key.localeCompare(b.key, undefined, { numeric: true }) : sort === "oldest" ? a.updated.localeCompare(b.updated) : sort === "attention" ? Number(Boolean(attentionReason(b))) - Number(Boolean(attentionReason(a))) || a.updated.localeCompare(b.updated) : b.updated.localeCompare(a.updated));
}
export function favouriteOrder(ids: string[], id: string, before?: string): string[] {
    if (id === before)
        return ids;
    const next = ids.filter(x => x !== id);
    const at = before ? next.indexOf(before) : -1;
    next.splice(at < 0 ? next.length : at, 0, id);
    return next;
}
export function projectRows(project: Project, issues: PersonalWorkIssue[]): PersonalWorkIssue[] {
    return issues.filter(i => i.projectIds.includes(project.projectId));
}
/** Personal relevance uses stable person slugs and assigned Jira work, never display names. */
export function relevantProjects(
    projects: Project[],
    issues: PersonalWorkIssue[],
    pinnedProjectIds: string[],
    personSlug?: string,
): Project[] {
    const related = new Set([...pinnedProjectIds, ...issues.flatMap(i => i.projectIds)]);
    const slug = personSlug?.trim().toLowerCase();
    return projects.filter(p => related.has(p.projectId) || Boolean(slug &&
        [p.owner, p.deputy, p.assignee].some(person => person?.trim().toLowerCase() === slug)));
}
export function projectBoardLink(id: string): string { return `/projects/${encodeURIComponent(id)}?tab=board&mine=1`; }
